<template>
    <div id="app">
        <div class="reportConfiguration-title">
            <Breadcrumb>
                <BreadcrumbItem>{{this.$route.query.companyName}}</BreadcrumbItem>
                <BreadcrumbItem>{{this.$route.query.reportDate}}</BreadcrumbItem>
                <BreadcrumbItem to="/operationKpiConfigurationManagement/operationReport">自动化运维报告</BreadcrumbItem>
            </Breadcrumb>
        </div>
        <template>
            <Tabs size="small" :value="currentTab" @on-click="currentTabChanged">
                <TabPane label="财务优化" name="financialOptimization">
                    <financial-optimization ref="financialOptimizationChild"></financial-optimization>
                </TabPane>
                <TabPane label="资源优化" name="resourceOptimization">
                    <resource-optimization ref="resourceOptimizationChild"></resource-optimization>
                </TabPane>
                <TabPane label="运维工作" name="operationMaintenance">
                    <operation-maintenance ref="operationMaintenanceChild"></operation-maintenance>
                </TabPane>
                <TabPane label="重大事件" name="majorEvent">
                    <major-event ref="majorEventChild"></major-event>
                </TabPane>
            </Tabs>
        </template>
    </div>
</template>

<script>
    import FinancialOptimization from '../report_configuration/FinancialOptimization'
    import ResourceOptimization from '../report_configuration/ResourceOptimization'
    import OperationMaintenance from '../report_configuration/OperationMaintenance'
    import MajorEvent from '../report_configuration/MajorEvent'
    export default {
        name: 'ReportConfiguration',
        components: {
            FinancialOptimization,
            ResourceOptimization,
            OperationMaintenance,
            MajorEvent
        },
        data() {
            return {
                currentTab:'',
                tabName:'financialOptimization'
            }
        },
        mounted: function () {
        },
        methods: {
            // 根据相应的tab名 调它下面相应的方法
            currentTabChanged(name){
                this.tabName=name;
                if(this.tabName=='financialOptimization'){

                }else if(this.tabName=='resourceOptimization'){

                }else if(this.tabName=='operationMaintenance'){

                }
            }
        }
    }
</script>

<style scoped>
    .reportConfiguration-title
    {
        width: 100%;
        font-size: 13px;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        padding: 15px 0px 8px 4px;
        font-weight: 600;
    }
    .ivu-breadcrumb {
        font-size: 13px;
        font-weight: 600;
        color: #515a6e;
    }
</style>



// WEBPACK FOOTER //
// src/components/configuration/operation_kpi_configuration_management/operation_report/report_configuration/ReportConfiguration.vue